import dayjs from "dayjs";

export function formatAssignedTimeline(
  deadlineFrom?: string,
  deadlineTo?: string
): string {
  if (!deadlineFrom || !deadlineTo) {
    return "—";
  }

  const from = dayjs(deadlineFrom);
  const to = dayjs(deadlineTo);

  if (!from.isValid() || !to.isValid()) {
    return "—";
  }

  return `${from.format("MMM D, hh:mm A")} - ${to.format("MMM D, hh:mm A")}`;
}
